var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tags",staticClass:"menu-tags"},[_vm._l((_vm.tags),function(tag){
var _obj;
return _c('div',{key:tag,staticClass:"menu-tag",class:( _obj = {}, _obj['menu-tag_selected'] = tag === _vm.menuTag, _obj ),on:{"click":function($event){return _vm.onClick(tag)}}},[_vm._v(" "+_vm._s(tag)+" ")])}),_c('div',{ref:"selectedBg",staticClass:"menu-tag_selected--background"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }